import * as API from '../api/HubSpotApi';

export const listUsers = API.listUsers;
